<template>
	<div>
		<v-data-table
			v-if="hasItens"
			:items="fiscais"
			:headers="colunas"
			item-key="id"
			hide-default-footer
			:server-items-length="totalItens"
			:options="paginacaoInterna"
			class="arp-listview mt-5 row-pointer"
		>
			<template #item.situacao="{ item }">
				<span> {{ filtrarSituacao(item.situacao) }} </span>
			</template>
			<template #item.dataCriacao="{ item }">
				<span> {{ item.dataCriacao | formatDataFilter }} </span>
			</template>
			<template #item.vigencia="{ item }">
				<span> {{ item.inicioVigencia | formatDataFilter }} - {{ item.fimVigencia | formatDataFilter }} </span>
				<v-icon v-if="vigenciaVencida(item.fimVigencia)" size="16" class="pb-1" color="orange">access_time</v-icon>
			</template>
			<template #item.acoes="{ item }">
				<fiscais-listagem-botoes-acoes
					:item="item"
					@editar="editar"
					@baixar="baixar"
					@excluir="excluir"
				>
				</fiscais-listagem-botoes-acoes>
			</template>
		</v-data-table>
		<paginacao-tabela
			v-if="hasItens"
			:page.sync="paginacaoInterna.page"
			:rows-per-page.sync="paginacaoInterna.rowsPerPage"
			:total-paginas="totalPaginas"
			:total-itens="totalItens"
			@resetar-page="resetarPage"
		></paginacao-tabela>
		<template-listagem-vazia :total-itens="totalItens" :textos="textoListagemVazia"></template-listagem-vazia>

		<modal-excluir-fiscal
			:exibir="exibirModalExclusaoFiscal"
			@fechar-modal="abrirOuFecharModalExclusaoFiscal"
			@confirmar-exclusao-fiscal="confirmarExclusaoFiscal"
		></modal-excluir-fiscal>
		<modal-baixar-anexo-fiscal
			v-if="exibirModalBaixarAnexoFiscal"
			:exibir="exibirModalBaixarAnexoFiscal"
			@fechar-modal="abrirOuFecharModalBaixarAnexoFiscal"
			:id-fiscal="idFiscalBaixarAnexo"
		>
		</modal-baixar-anexo-fiscal>
		<modal-adicionar-fiscal
			v-if="exibirModalEdicaoFiscal"
			:exibir="exibirModalEdicaoFiscal"
			:fiscal="fiscalEdicao"
			@fechar-modal="abrirOuFecharModalEdicaoFiscal"
			@confirmar-edicao-fiscal="confirmarEdicaoFiscal"
			titulo-modal="Editar Fiscal"
			:repositorio-flowbee="repositorioFlowbee"
		>
		</modal-adicionar-fiscal>
	</div>
</template>
<script>
import tabelaMixin from '@/views/mixins/tabela'
import { DataUtils, TabelaColunaUtils } from '@/core/utils'
import TemplateListagemVazia from '@/views/components/TemplateListagemVazia.vue'
import situacaoFilter from '@/views/filters/situacao-filter'
import { actionTypes, situacoes } from '@/core/constants'
import FiscaisListagemBotoesAcoes from '@/views/pages/configuracao/fiscais/listagem/botoes-acoes/FiscaisListagemBotoesAcoes.vue'
import formatDataFilter from '../../../../filters/format-data-filter'
import ModalExcluirFiscal from '@/views/pages/configuracao/fiscais/listagem/modal-excluir-fiscal/ModalExcluirFiscal.vue'
import ModalBaixarAnexoFiscal from '@/views/pages/configuracao/fiscais/listagem/modal-baixar-anexo-fiscal/ModalBaixarAnexoFiscal.vue'
import ModalAdicionarFiscal from '@/views/pages/configuracao/fiscais/modal-adicionar-fiscal/ModalAdicionarFiscal.vue'

export default {
	name: 'fiscais-listagem',
	components: {
		ModalAdicionarFiscal,
		ModalBaixarAnexoFiscal,
		ModalExcluirFiscal,
		FiscaisListagemBotoesAcoes,
		TemplateListagemVazia,
	},
	mixins: [tabelaMixin],
	props: {
		fiscais: {
			type: Array,
			required: true,
		},
		repositorioFlowbee: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			colunas: [
				new TabelaColunaUtils('Fiscal', 'nomeFiscal', '25%'),
				new TabelaColunaUtils('Órgão', 'siglaOrgao', '15%'),
				new TabelaColunaUtils('Data Criação', 'dataCriacao', '15%'),
				new TabelaColunaUtils('Vigência', 'vigencia', '20%'),
				new TabelaColunaUtils('Situação', 'situacao', '15%'),
				new TabelaColunaUtils('Ações', 'acoes', '10%'),
			],
			textoListagemVazia: {
				titulo: 'Nenhum fiscal foi encontrado',
			},
			paginacaoInterna: this.paginacao,
			exibirModalExclusaoFiscal: false,
			exibirModalEdicaoFiscal: false,
			idFiscalExclusao: null,
			idFiscalBaixarAnexo: null,
			exibirModalBaixarAnexoFiscal: false,
			fiscalEdicao: {},
		}
	},
	methods: {
		formatDataFilter,
		async resetarPage() {
			await this.$emit('resetar-page')
			await this.$emit('recarregar-listagem-modelo-documento')
		},
		filtrarSituacao(situacao) {
			return situacaoFilter(situacao, situacoes.FISCAIS)
		},
		abrirOuFecharModalExclusaoFiscal() {
			this.exibirModalExclusaoFiscal = !this.exibirModalExclusaoFiscal
		},
		abrirOuFecharModalBaixarAnexoFiscal() {
			this.exibirModalBaixarAnexoFiscal = !this.exibirModalBaixarAnexoFiscal
		},
		baixar(idFiscal) {
			this.idFiscalBaixarAnexo = idFiscal
			this.abrirOuFecharModalBaixarAnexoFiscal()
		},
		abrirOuFecharModalEdicaoFiscal() {
			this.exibirModalEdicaoFiscal = !this.exibirModalEdicaoFiscal
		},
		editar(idFiscal) {
			this.fiscalEdicao = this.fiscais.find((fiscal) => fiscal.id === idFiscal)
			this.abrirOuFecharModalEdicaoFiscal()
		},
		excluir(idFiscal) {
			this.idFiscalExclusao = idFiscal
			this.abrirOuFecharModalExclusaoFiscal()
		},
		async confirmarExclusaoFiscal() {
			await this.$store.dispatch(actionTypes.CONFIGURACAO.FISCAIS.EXCLUIR_FISCAL, this.idFiscalExclusao)
			this.idFiscalExclusao = null
			this.mostrarNotificacaoSucessoDefault()
			this.abrirOuFecharModalExclusaoFiscal()
			await this.resetarPage()
		},
		async confirmarEdicaoFiscal(data) {
			await this.$store.dispatch(actionTypes.CONFIGURACAO.FISCAIS.EDITAR_FISCAL, data)
			this.fiscalEdicao = {}
			this.mostrarNotificacaoSucessoDefault()
			this.abrirOuFecharModalEdicaoFiscal()
			await this.resetarPage()
		},
		vigenciaVencida(fimVigencia) {
			return DataUtils.isVencido(fimVigencia)
		},
	},
}
</script>
